import { LogoProviderManager } from './LogoProviderManager';
import { NounProjectProvider } from './NounProjectProvider';
import { PurchasedNounProvider } from './PurchasedNounProvider';
import { WixNounProvider } from './WixNounProvider';
import { PurchasedSearchNounProvider } from './PurchasedSearchNounProvider';
import { PurchasedProvider } from './PurchasedProvider';
export function createIconsProvider(logoWebappApiV2, iconsServerApi, industryService, options) {
  var logoProviderManager = new LogoProviderManager({
    logoWebappApi: logoWebappApiV2,
    iconsServerApi: iconsServerApi,
    industryService: industryService
  }, options);
  var nounProjectProvider = new NounProjectProvider(logoWebappApiV2, options);
  var wixNounProvider = new WixNounProvider(logoWebappApiV2, options);
  var purchasedNounProvider = new PurchasedNounProvider();
  var purchasedSearchNounProvider = new PurchasedSearchNounProvider();
  var purchasedProvider = new PurchasedProvider();
  logoProviderManager.addProvider(wixNounProvider);
  logoProviderManager.addProvider(nounProjectProvider);
  logoProviderManager.addProvider(purchasedNounProvider);
  logoProviderManager.addProvider(purchasedSearchNounProvider);
  logoProviderManager.addProvider(purchasedProvider);
  return logoProviderManager;
}